// src/components/navigation/BottomNav.js
import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { BottomNavigation, BottomNavigationAction, Paper } from "@mui/material";

import HomeIconDefault from "../../assets/icons/home-default.svg";
import HomeIconActive from "../../assets/icons/home-active.svg";
import WatchIconDefault from "../../assets/icons/watch-default.svg";
import WatchIconActive from "../../assets/icons/watch-active.svg";
import MessageIconDefault from "../../assets/icons/message-default.svg";
import MessageIconActive from "../../assets/icons/message-active.svg";
import TimeCapsuleIconDefault from "../../assets/icons/icon-time-capsules-default.svg";
import TimeCapsuleIconActive from "../../assets/icons/icon-time-capsules-active.svg";
// import SettingsIconDefault from "../../assets/icons/settings-default.svg";
// import SettingsIconActive from "../../assets/icons/settings-active.svg";

const BottomNav = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [value, setValue] = useState(0);

  // Update the bottom nav value based on the current route
  useEffect(() => {
    const path = location.pathname;
    if (path === "/") {
      setValue(0);
    } else if (path.includes("/watch")) {
      setValue(1);
    } else if (path.includes("/series")) {
      setValue(1);
    } else if (path.includes("/messages/drop")) {
      setValue(2);
    } else if (path.includes("/messages")) {
      setValue(3);
    } else if (path.includes("/timecapsule")) {
      setValue(2);
    }
  }, [location.pathname]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    // Navigate to the corresponding route based on the selected tab
    if (newValue === 0) {
      navigate("/");
    } else if (newValue === 1) {
      navigate("/watch");
    } else if (newValue === 2) {
      navigate("/messages/drop");
    } else if (newValue === 3) {
      navigate("/messages");
    }
  };

  return (
    <Paper
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        boxShadow: "none", // Removes box shadow
        border: "none", // Ensures no border
        height: "60px", // Sets the height to 90px
      }}
      elevation={0} // Removes elevation (also removes shadow)
    >
      <BottomNavigation
        value={value}
        onChange={handleChange}
        sx={{
          height: "100%",
          display: "flex",
          justifyContent: "space-around", // Evenly spaces icons
          alignItems: "center",
        }}
      >
        <BottomNavigation
          value={value}
          onChange={(event, newValue) => setValue(newValue)}
          sx={{ height: "100%", width: "100%" }}
        >
          <BottomNavigationAction
            icon={
              <img
                src={value === 0 ? HomeIconActive : HomeIconDefault}
                alt="Home"
                width={24}
              />
            }
          />
          <BottomNavigationAction
            icon={
              <img
                src={value === 1 ? WatchIconActive : WatchIconDefault}
                alt="Watch"
                width={33}
              />
            }
          />
          <BottomNavigationAction
            icon={
              <img
                src={value === 2 ? MessageIconActive : MessageIconDefault}
                alt="Messages"
                width={30}
              />
            }
          />
          <BottomNavigationAction
            icon={
              <img
                src={value === 3 ? TimeCapsuleIconActive : TimeCapsuleIconDefault}
                alt="Time Capsules"
                width={25}
              />
            }
          />
        </BottomNavigation>
      </BottomNavigation>
    </Paper>
  );
};

export default BottomNav;
